export enum MissionCategory {
  Food = 101,
  Move = 102,
  Mind = 103,
  OpenMission = 501, // includes video
  Survey = 104
}
